import { InfoOutlined } from "@mui/icons-material";
import {
  FormControl,
  FormHelperText,
  InputAdornment,
  InputLabel,
  Select,
  Typography,
} from "@mui/material";
import React from "react";
import LoadingSection from "../loading/LoadingSection";

function SelectInput({
  value,
  onChange,
  children,
  label,
  renderValue,
  variant,
  StartIcon,
  size,
  error,
  onBlur,
  onFocus,
  fullWidth,
  width,
  placeholder,
  disabled,
  onOpen,
  onClose,
  required,
  sx,
  helperText,
  showErrorIcon,
  className,
  readOnly,
  defaultValue,
  margin,
  endIcon,
  loading,
  hiddenLabel,
  id,
}) {
  return (
    <FormControl
      error={error}
      margin={margin}
      sx={{ width: width }}
      variant={variant}
      size={size}
      required={required}
      hiddenLabel={hiddenLabel}
      fullWidth={fullWidth || true}
    >
      <InputLabel size={size} required={required} id="default-select-label">
        {label}
      </InputLabel>
      <Select
        id={id}
        labelId="default-select-label"
        sx={{
          ...sx,
        }}
        size={size}
        hiddenLabel={hiddenLabel}
        MenuProps={{
          elevation: 1,
          disableScrollLock: true,
          PaperProps: {
            sx: {
              boxShadow: 5,
            },
          },
        }}
        startAdornment={
          StartIcon && (
            <InputAdornment position="start">
              <StartIcon />
            </InputAdornment>
          )
        }
        endAdornment={
          endIcon && <InputAdornment position="end">{endIcon}</InputAdornment>
        }
        required={required}
        displayEmpty={Boolean(placeholder)}
        renderValue={
          value
            ? renderValue
            : () => (
                <Typography
                  component={"span"}
                  variant="inherit"
                  color="textDisabled"
                >
                  {placeholder}
                </Typography>
              )
        }
        readOnly={readOnly}
        onOpen={onOpen}
        onClose={onClose}
        defaultValue={defaultValue}
        disabled={disabled}
        onFocus={onFocus}
        className={className}
        onBlur={onBlur}
        placeholder={placeholder}
        error={error}
        value={value}
        label={label}
        onChange={(e) => onChange(e.target.value)}
      >
        {loading ? <LoadingSection h={100} /> : children}
      </Select>
      {error && (
        <FormHelperText
          sx={{ color: "#F24B4B", display: "flex", alignItems: "center" }}
        >
          {showErrorIcon && (
            <InfoOutlined fontSize="small" sx={{ mr: 1, ml: -1 }} />
          )}{" "}
          {helperText}
        </FormHelperText>
      )}
    </FormControl>
  );
}

export default SelectInput;
